<template>
  <div>
    <Title :title="'电池衰减度测评'" :isWidth700="true"></Title>
    <Chart :cdata="cdata" :height="style.height"/>
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      style:{
        // width: '800',
        height: '200'
      },
      cdata: {
        category: [],
        rateData: [],
        id:"carAddChart",
        legendData:[],
        series:[
            {
              barGap: "-100%", /*这里设置包含关系，只需要这一句话*/
              name: "",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#65E2B6" },
                    { offset: 1, color: "#B8FF7E " }
                  ])
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: "",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#FFFFFF" },
                    { offset: 1, color: "#FFFFFF " }
                  ]),
                  opacity: 0.23
                }
              },
              data: [100,100,100,100,100,100,100,100,100,100,100,100]
            },
        ],
        yAxisname:"%"
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryDecayCurrent(data)
    },
    selectBatteryDecayCurrent(data={}){
      let _this = this;
      let params = {
				"enCode":"TiDB-congdiancang-dianchishuaijiandupingce",//TiDB-充电仓-电池衰
        "@station_id":data.stationId,
        "@battery_id":data.batteryId
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let BatteryDamping = [];
          let xList = [];
          res.forEach(item=>{
            BatteryDamping.push(item.BatteryDamping);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = BatteryDamping;
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>